import FeedbackPage from '@/components/FeedbackPage'
import { SparklesIcon } from '@heroicons/react/24/outline'

export default function LifestyleImpactIntroPage() {
  return (
    <FeedbackPage
      icon={<SparklesIcon className="h-8 w-8 text-white" />}
      headingKey="pages.onboarding.lifestyleImpactIntro.heading"
      descriptionKey="pages.onboarding.lifestyleImpactIntro.description"
    />
  )
}
